// Laftel Analytics: named actions and the signed-in flag (see maheroku/Analytics). The loader in
// public/index.html queues calls until the tracker loads; elsewhere (local dev, tests) they do nothing.
export const track = (name, props) => window.laftel?.track?.(name, props);

export const setSignedIn = (value) => window.laftel?.signedIn?.(value);
